import { Modal } from 'stream-chat-react'
import * as React from 'react'

type IComponentProps = React.PropsWithChildren<{
  isOpen: boolean
  onClose: () => void
  className?: string
}>

const ChatModal = (props: IComponentProps) => {
  return (
    <Modal open={props.isOpen} onClose={props.onClose} className={`str-chat chat-modal ${props.className ?? ''}`}>
      {props.children}
    </Modal>
  )
}

export default ChatModal
